import { createClient, fetchExchange } from "@urql/core";
import { authHeader } from "@/services/auth";

const vueAppMagentoGraphqlUrl = import.meta.env.VITE_APP_GRAPHQL_API;
let client;

export function getGraphqlClient({ passAuthHeader = true }) {
  return createClient({
    url: vueAppMagentoGraphqlUrl,
    exchanges: [fetchExchange],
    requestPolicy: 'network-only',
    fetchOptions: () => {
      const headers = {
        "Content-Type": "application/json",
        "Magento-Store-View-Code": "default",
        "Magento-Website-Code": "base",
        "Magento-Store-Code": "default",
      };

      try {
        const auth = authHeader && authHeader();
        if (typeof auth === "string" && auth && passAuthHeader) {
          headers["Authorization"] = auth;
        } else if (auth && typeof auth === "object" && passAuthHeader) {
          Object.assign(headers, auth);
        }
      } catch (e) {
        console.warn("authHeader error", e);
      }

      return { headers };
    },
  });
}
